module.exports = __webpack_public_path__ + "media/images/emblems/Mandach-blason-0039c4f2524894cec9aeadce4d1e09f0.png";